import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) =>
  createStyles({
    "@global": {
      "*": {
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
      },
      html: {
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        height: "100%",
        width: "100%",
        /**
         * Lloyds-only: the base app shrinks the root font to 0.75rem below the
         * `md` breakpoint. The LBG mobile designs are specified in real pixels
         * (13px body, 26px headlines), and with the Lloyds `body1: 0.875rem`
         * that downscale would render body copy at ~9.8px. The mobile layouts
         * size themselves explicitly, so the root font stays at 100% here.
         */
        color: theme.palette.text.primary,
      },
      body: {
        background: theme.palette.background.gradient || theme.palette.background.default,
        height: "100%",
        width: "100%",
      },
      a: {
        cursor: "pointer",
      },
      /**
       * Prevents auto zoom into the input field on iPhone and iOS
       * when the font-size of an input element is less 16px.
       *
       * The 16px floor is non-negotiable on iOS, but the base padding
       * (`1.2rem 1rem`) makes the field far taller than the compact search box
       * in the LBG designs, so it is tightened here.
       */
      ".MuiInputBase-input": {
        [theme.breakpoints.down("md")]: {
          fontSize: "1rem",
          padding: "10px 12px",
          "&::placeholder": {
            fontSize: "1rem",
          },
        },
      },
      "#root": {
        height: "100%",
        width: "100%",
      },
      ".hidden": {
        clip: "rect(1, 1, 1, 1)",
        clipPath: "inset(50%)",
        height: 1,
        width: 1,
        margin: -1,
        overflow: "hidden",
        padding: 0,
        position: "absolute",
      },
    },
  }),
);

/**
 * An empty component that applies global styles.
 */
const GlobalStyles = () => {
  useStyles();
  return null;
};

export default GlobalStyles;
